var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"fas fa-times close-modal",on:{"click":function($event){return _vm.$modal.hide(_vm.modalName)}}})}
var staticRenderFns = []

export { render, staticRenderFns }